import { Injectable } from '@angular/core';
import { StorageService } from '../../core/service/storage.service';
import { ImportantNoticeSource } from '../model/important-notice';

const SHOWN_NOTICE_STORAGE_KEY = 'dinHyresvard.shownImportantNotices';

@Injectable({ providedIn: 'root' })
export class ImportantNoticePresentationService {
  constructor(private readonly storageService: StorageService) {}

  hasBeenShown(source: ImportantNoticeSource, noticeId: string): boolean {
    return this.getShownNoticeKeys().includes(this.getNoticeKey(source, noticeId));
  }

  markAsShown(source: ImportantNoticeSource, noticeId: string): void {
    const noticeKey = this.getNoticeKey(source, noticeId);
    const shownNoticeKeys = this.getShownNoticeKeys();

    if (!shownNoticeKeys.includes(noticeKey)) {
      this.storageService.set(SHOWN_NOTICE_STORAGE_KEY, JSON.stringify([...shownNoticeKeys, noticeKey]), true);
    }
  }

  clear(source: ImportantNoticeSource, noticeId: string): void {
    const noticeKey = this.getNoticeKey(source, noticeId);
    const shownNoticeKeys = this.getShownNoticeKeys().filter(key => key !== noticeKey);

    if (shownNoticeKeys.length === 0) {
      this.storageService.removeValue(SHOWN_NOTICE_STORAGE_KEY, true);
      return;
    }

    this.storageService.set(SHOWN_NOTICE_STORAGE_KEY, JSON.stringify(shownNoticeKeys), true);
  }

  clearAll(): void {
    this.storageService.removeValue(SHOWN_NOTICE_STORAGE_KEY, true);
  }

  private getShownNoticeKeys(): string[] {
    const storedValue = this.storageService.getValue(SHOWN_NOTICE_STORAGE_KEY, true);

    if (!storedValue) {
      return [];
    }

    try {
      const parsedValue: unknown = JSON.parse(storedValue);
      return Array.isArray(parsedValue) && parsedValue.every(value => typeof value === 'string') ? parsedValue : [];
    } catch {
      return [];
    }
  }

  private getNoticeKey(source: ImportantNoticeSource, noticeId: string): string {
    return `${source}:${noticeId}`;
  }
}
